export default "__VITE_ASSET__DLXUqquE__"